import React, { useEffect, useState } from "react"
import UploadContainer from "../../Common/UploadContainer"
import SetupForm from "../SetupForm"
import BaseContainer from "../../Common/BaseContainer"
import {
  getSelfProfileInfo,
  setupProfile,
} from "../../../store/entities/Profile/Profile.actions"
import { useDispatch, useSelector } from "react-redux"
import {
  selectProfileInfo,
  selectProfileLoading,
} from "../../../store/selectors/Profile"
import URLS from "../../../config/navigation"
import { useHistory, useLocation } from "react-router-dom"
import HelmetComponent from "../../Common/Helmet"
import Toast from "../../Common/Toast"
import ToastMessage from "../../Common/ToastMessage"

const SetupProfile = ({
  title = "Let’s set up your profile",
  submitBtnTitle = "Continue",
  displayLogo = true,
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const profileInfo = useSelector(selectProfileInfo)
  const [file, setFile] = useState(profileInfo.avatar)
  const isLoading = useSelector(selectProfileLoading)
  const history = useHistory()

  useEffect(() => {
    setFile(profileInfo.avatar)
  }, [profileInfo.avatar])

  useEffect(() => {
    dispatch(getSelfProfileInfo())
  }, [])

  const callback = () => {
    if (location.pathname === URLS.SETTINGS.EDIT) {
      return
    } else {
      setTimeout(() => {
        history.push(URLS.PUBLIC.LINK)
      }, 1000)
    }
  }

  const submitSetupProfile = (values) => {
    if (file) {
      const bodyFormData = new FormData()
      const teacher = { file, ...values }
      Object.keys(teacher).forEach((item) => {
        bodyFormData.append(item, teacher[item])
      })
      dispatch(
        setupProfile(bodyFormData, callback, () =>
          Toast(ToastMessage(10), "error")
        )
      )
    } else {
      const bodyFormData = new FormData()
      const teacher = { ...values }
      Object.keys(teacher).forEach((item) => {
        bodyFormData.append(item, teacher[item])
      })
      dispatch(
        setupProfile(bodyFormData, callback, () =>
          Toast(ToastMessage(10), "error")
        )
      )
    }
  }

  return (
    <BaseContainer title={title} displayLogo={displayLogo}>
      <HelmetComponent title="Edit Profile - TeachOn" />
      <UploadContainer initSrc={file} setFile={setFile} />
      <SetupForm
        loading={isLoading}
        submitBtnTitle={submitBtnTitle}
        handleSubmit={submitSetupProfile}
      />
    </BaseContainer>
  )
}

export default SetupProfile
